// @flow

import removeOrderGroup from '../../../Services/removeOrderGroup';
import type { RemoveOrderGroupParams } from '../../../types';

export default (params: RemoveOrderGroupParams) => async (dispatch: Function) => dispatch(removeOrderGroup(params))